const {
  REACT_APP_ACCESS_TOKEN_COOKIE_NAME,
  REACT_APP_REFRESH_TOKEN_COOKIE_NAME,
  REACT_APP_USER_TYPE_COOKIE_NAME
} = process.env

export const ACCESS_TOKEN_KEY = REACT_APP_ACCESS_TOKEN_COOKIE_NAME
export const REFRESH_TOKEN_KEY = REACT_APP_REFRESH_TOKEN_COOKIE_NAME
export const USER_TYPE_KEY = REACT_APP_USER_TYPE_COOKIE_NAME
